<template>
	<div class="addDevice tableSys pb05x" :class="{h25x:isMinHeight && flag}" v-clickoutside="handleClose"  @mouseleave="showDeviceMousePos=false" @mouseenter="showDeviceMousePos=true">
		<div class="posR drop-list-box" >
			  <transition-group tag="div" class="enableList  bdSub boxR-light cb tra ml05x_E pb05x mt05x_E fL_E pr3x"  v-on:leave="el=>{transitionAction(el,'hide-x');}" :duration="500">
		        <button v-if="temp.length>0" class="clearTag hover-f-error hover-effect-rotate tra-fast" :key="'clear'" @click="clear" type="button"><div class="icoSys w1x h1x bgSub fSub fs16x"><Icon name="no" /></div></button>
		        <TagBox v-for="(item,index) in temp" :key="item.deviceId" :styleType="'tag'" :val="rs(item.deviceType,item.deviceSn)" :data="item" @Remove="onRemove(item,index)"></TagBox>
		        <button :key="'add'" class="lh15 cMain" type="button" @click.stop="getList">{{'+'+getLanguageStr('phrase983','选择子设备')}}</button>
			</transition-group>
			<div  v-show="flag" >
				<loading  ref="loading"></loading>
				<div class="posR bdSub h10x-min">
					<div class="tableSys bdSub-bottom">
				    	<div class="ml1x mr1x pt05x pb05x taC inputWrap">
				      	 <InputText class="w20x dpIB" @AfterClear="afterclear"
				      	 	 :fn="getList" 
				      	 	 :autocomplete="'off'"
				      	 	 :placeholder="getLanguageStr('phrase984','输入设备序列号')"
				      	 	 :addClass="{bgContent:true}" name="alertName"  
				      	 	 :clearBtn="true" ref="searchBox" :searchBtn="true" v-model="searchText">
				      	 </InputText>
				      	</div>
				      	<div class="taR pr1x ml1x_E cSub fSub_E">
		                    <span>{{$t('word13',['更新于'])+"："+timeFormat(updateTime,'system','%Y/%m/%d %H:%M:%S')}}</span>
		                    <button :title="$t('cmd7',['刷新'])" type="button" @click="getList"><Icon name="refresh" class="w1x h1x" :sizeBase="'m'" /></button>
		                </div>
		            </div>
					<div class="pl05x pr05x" v-show="list.length">
					 <Checkbox :text="$t('cmd91',['全选'])"  @Click="selectData" class="pl05x pt05x" :disabled="checkAllDisable?true:false" :class="checkAllDisable?'disabled':''" :data="list" :keyMap="'checked'" ></Checkbox>
					 <div>
						<ul class="listDevice h20x-max" scroll>
							<li v-for="(item,index) in list" :key="index" class="vaM_E" :class="['posR',{'peN disabled':item.existing}]">
								<div class="layer">{{$t('phrase831',['该设备已加入电站，无法添加'])}}</div>
								<Checkbox @Click="selectData(item.checked,index)" :index="item.deviceId" v-model="item.checked" :disabled="item.existing?true:false"></Checkbox>
							  	<div class="w15x dpIB">
							  		<span :title="getTypeText(item.deviceType,'deviceType')" >{{item.deviceType?getTypeText(item.deviceType,'deviceType'):'--'}}</span>	
							  		<span :title="item.name">{{item.deviceSn}}</span>
							  	</div>
							  	<span v-if="item.deviceState==null" class="w4x dpIB">--</span>
								<StatusIco v-else :id="item.deviceState" :type="'device'" class="w4x dpIB"></StatusIco>
								<span>{{item.collectionTime?timeFormat(item.collectionTime,'utc','%Y/%m/%d %H:%M',{offset:timezone||stage.time.timeZoneCode}):'--'}}</span>
							</li>
						</ul>
					</div>
					</div>
					<div class="no-data h5x-min taC pt2x" v-show="!list.length">
						{{$t('word1380',['暂无数据'])}}
					</div>
				</div>
			</div>
			<!--<div class="toolBar taR vaM_E">
				<button class="bdSub hover-bg-highLight" :title="getLanguageStr('cmd85','取消')" @click.stop="hide" type="button">{{getLanguageStr('cmd85','取消')}}</button>
				<button :class="{'disable':temp.length==0}" class="fR functionBtn" :title="getLanguageStr('cmd12','确定')" @click="makeSure">{{getLanguageStr('cmd12','确定')}}({{temp.length}})</button>
			</div>-->
		</div>
	</div>
</template>
<script>
import StatusIco from '@/components/common/ui/StatusIco.vue'
import TagBox from '@/components/common/ui/TagBox'
import clickoutside from '@/plugins/clickOutSide/index.js'
import {getLanguageStr} from '@/util/language.js'
import {GetSystemDevice} from '@/api/maintain/plant/list'
import Checkbox from '@/components/common/ui/Checkbox.vue'
import InputText from '@/components/common/ui/InputText.vue'
import List from '@/components/common/AddDevice/List'
import NoResult from '@/components/common/ui/NoResult'
import Loading from '@/components/common/ui/Loading'
import Select from '@/components/common/ui/Select.vue'
import MyRadio from '@/components/common/ui/Radio'
import * as lib from '@/util/lib.js'
export default {
  name: 'newDeviceLine',
  components: {StatusIco,TagBox,InputText, Checkbox, List, NoResult, Select, Loading, MyRadio},
  directives: { clickoutside },
  props: {
    id: {
      type: Number
    },
    data: {
      type: Object
    },
    buttonType: {
      type: String,
      default: 'add'
    },
    timezone:{
      type:String,
      default:stage.time.timeZoneCode
    },
    isMinHeight: {
      type: Boolean,
      default: false
    },
    initList:{
    	type:Array,
    	default: () => ([])
    },
    max:{
    	  type: Number,
      default: 10000
    }
  },
  data () {
    return {
    	isEdit:false,
    	showDeviceMousePos:false,
    	flag:false,
    	checkall:false,
    	searchText: '',
    	checkAllDisable:false,
	    temp:[],
        type: 0,
        list: [],
        stage,
        drop: false,
        searchText: '',
        updateTime: new Date(),
        pagination: {},
        refresh: false, // 记录是否是刷新状态，还原已添加的id
        selectIds: [],
        existingIds: [],
		selectAllStatus: 0,
		jishu:0
    }
  },
  methods: {
  	transitionAction: lib.transitionAction,
    getLanguageStr,
    getTypeText: lib.getTypeText,
    timeFormat: lib.timeFormat,
    show(v){//true来自编辑 false来自新增
    	if(v){
    		this.isEdit=v
    		this.flag=false;
    		this.temp=_.cloneDeep([])
    	}else{
    		this.$nextTick(() => {
	        this.temp= _.cloneDeep(this.initList)
	    })
    	}
    },
    clear () {
	      this.temp = []
	      this.list.forEach(el => {
	        this.$set(el, 'checked', false)
	      })
	      this.selectAllStatus=0
	      this.checkall=false
	      this.valueOf(this.temp)
    },
    rs(t,n){
    	return this.getTypeText(t,'deviceType')+'  '+n
    },
   afterclear: function () {
    	this.searchText=''
	     this.getList();
	    },
    handleClose (e) {
     if (!this.showDeviceMousePos) {
     	this.searchText=''
        this.flag = false
      }
    },
     selectData (val, index) {
      if(this.temp.length<this.max||val==false){
        if ($.type(val) == 'boolean' && index >= 0) {
        } else if (index == 'all') {
          let cont=0;
          this.list.forEach((el, index) => {
            if(cont<this.max){
              if(!el.existing){
                   this.$set(el, 'checked', val);
                  if(el.checked){
                    ++cont;
                 }
              }        
            }
            else{//超出最大数
              this.$notify(i18n.t('fill3rd75',[this.max,'选择的数量不能超过{0}']));
              return false;
            }
          })
        }
        this.selectedData()
      }
      else{
        this.$nextTick(()=>{
          if($.isNumeric(index)) this.list[index].checked=false;
        });
        this.$notify(i18n.t('fill3rd75',[this.max,'选择的数量不能超过{0}']));
      }
    },
    selectedData () {
      let selectIdMap={};
      $.each(this.temp,(index,val)=>{
        selectIdMap[String(val.deviceId)]=val;
      });
       let tempList=[];
       this.list.map((item,index)=>{
   	    	if(!item.existing){
   	    			tempList.push(item);
   	    		}
        })
      let i=0;
      while(i<tempList.length){
        if(selectIdMap[String(tempList[i].deviceId)]){
        }
        else{//没有记录则添加进已选
          this.temp.push(tempList[i]);
        }
        ++i;
      };
      tempList=this.list.filter(el => !el.checked);
      i=0;
      while(i<tempList.length){//遍历已取消的
        $.each(this.temp,(index,val)=>{//找出需要剔除的
          if(val.deviceId==tempList[i].deviceId){
            this.temp.splice(index,1);
            --i;
            return false;
          }
        });
        ++i;
      };
      this.list=_.cloneDeep(this.list)//请注意必须。不然不会渲染
      this.valueOf(this.temp)
    },
    refreshList () {
      this.updateTime = new Date()
      this.refresh = true
      this.getList()
    },
    getList () {
      this.flag=true;
      this.selectAllStatus = 0
      this.$refs.loading.show()
      let pages = {
        page: 1,
        size: 2500,
        deviceSn: this.searchText
      }
      GetSystemDevice(this.data.sn, pages).then(res => {
        this.$refs.loading.hide()
        if (res.total > 0) {
        	 this.jishu=0
	         res.data.forEach((val, index) => {
	          	if(val.existing){
	          		 this.jishu++
	          	}
	         })
		}
        this.list = res.data
         this.list.forEach((el, index) => {
        	   	if(el.existing){
        	   		this.$set(el, 'checked', true)
        	   	}
        	});
        this.$nextTick(() => {
       	  lib.setScroll($(this.$el).find('[scroll]'))
          this.refresh = false
        })
        if(this.temp.length>0){
        	   this.list.forEach((el, index) => {
	            this.temp.forEach(attr => {
	              if (el.deviceId === attr.deviceId) {
	                el.checked = true
	              }
	            })
	          })
	    }
      }, error => {
        this.$refs.loading.hide()
        !_.isEmpty(error) && this.$notify(error)
      })
    },
    valueOf(data){
		let existingIds = []
		data.forEach((val, index) => {
          existingIds.push({deviceId: val.deviceId, gatewayId: val.gatewayId})
        })
	    this.$emit('update',existingIds,data)
		this.searchKey = ''
    },
    onRemove(i,index){
    	 let pos = this.temp.indexOf(i);
         this.temp.splice(pos, 1)
         for(let n = 0; n< this.list.length; n++) {
			if (this.list[n].deviceId === i.deviceId) {
				this.list[n].checked=false;
				break;
			}
		}
         this.valueOf(this.temp)
    },
    hide(){
    	this.flag=false
    	this.searchText=''
    	this.$emit('hide')
    }
  },
  mounted () {
  	this.flag=false
    lib.fillHeight()
    lib.setScroll($(this.$el).find('.addDevice[scroll]'))
  }
}
</script>
<style lang="scss" scoped>
.listDevice li{
	list-style-type: none;
    line-height: 2.5em;
    height: 2.5em;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    padding:0 0.5em
}
.enableList .clearTag{
    position: absolute;
    top: 0;
    right: .5em;
}
.disabled{
	 background-color: rgba(102, 131, 153, 0.06);
	 color:#c0c0c0
}
.peN .layer{
	display: block;
}
.layer{
	display: none;
	position: absolute;
    left: 0;
    width: 100%;
    height:2.5em;
    background: rgba(0,0,0,0.4);
    line-height: 2.5em;
    color: #fff;
    z-index: 2;
    cursor:not-allowed;
    text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/common/AddDevice/NewDevice.vue